import Components from "../components";

const MAPPINGS = {
  13: 'enter',
  27: 'esc',
  32: 'space',
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
  191: '/',
  112: 'F1'
};

class HotKey extends Components.Base {
  bind() {
    this.on($(document), 'keydown', e => this.onKeyDown(e));
  }

  onKeyDown(e) {
    if (this.$el && e.target.nodeName.toLowerCase() === 'body') {
      if (this.codeIsMatch(e.keyCode) && this.modifierIsMatch(e)) {
        e.stopPropagation();
        e.preventDefault();
        this.execute();
      }
    }
  }

  execute() {
    throw new Error('Execute must be implemented by child class');
  }

  codeIsMatch(keyCode) {
    const code = this.key(keyCode);
    return code && this.$el.attr('data-hotkey') === code;
  }

  modifierIsMatch(e) {
    return !e.metaKey && !e.ctrlKey && !e.altKey && this.shiftIsMatch(e);
  }

  shiftIsMatch(e) {
    const requireShift = this.$el.attr('data-hotkey-shift');
    return (
      requireShift == null ||
      (requireShift === 'true' && e.shiftKey) ||
      (requireShift === 'false' && !e.shiftKey)
    );
  }

  key(code) {
    if (MAPPINGS[code]) {
      return MAPPINGS[code];
    }
    if (code >= 48 && code <= 90) {
      return String.fromCharCode(code).toLowerCase();
    }
    return null;
  }
}

class HotKeyLink extends HotKey {
  execute() {
    const el = this.$el.closest('a')[0];

    if (!el.getAttribute('disabled')) {
      el.click();
    }
  }
}

class HotKeyButton extends HotKey {
  execute() {
    const el = this.$el.closest('button')[0];

    if (!el.getAttribute('disabled')) {
      el.click();
    }
  }
}

class HotKeySelect extends HotKey {
  execute() {
    this.$el
      .closest('select')
      .val(this.$el.val())
      .trigger('change');
  }
}

class HotKeyFocus extends HotKey {
  bind() {
    this.on('keydown', e => this.unfocusOnEsc(e));
    super.bind();
  }

  unfocusOnEsc(e) {
    if (this.key(e.keyCode) === 'esc') {
      this.$el.blur();
    }
  }

  execute() {
    this.$el.focus();
  }
}

class HotKeyClickNearest extends HotKey {
  execute() {
    const el = this.$el.closest('[data-hotkey]')[0];

    if (!el.getAttribute('disabled')) {
      el.click();
    }
  }
}

Components.collection.register({
  selector: 'a[data-hotkey]',
  klass: HotKeyLink,
});
Components.collection.register({
  selector: 'option[data-hotkey]',
  klass: HotKeySelect,
});
Components.collection.register({
  selector: 'input[data-hotkey]',
  klass: HotKeyFocus,
});
Components.collection.register({
  selector: 'button[data-hotkey]',
  klass: HotKeyButton,
});
Components.collection.register({
  selector: 'i[data-hotkey]',
  klass: HotKeyClickNearest,
});
